import AppErrorOverlay from './container/AppErrorOverlay'

export default AppErrorOverlay
